<div class="header-main">
  <ng-container *ngIf="imageURL">
    <img class="header-logo" *ngIf="imageURL" [src]="getSafeImageUrl(imageURL)">
  </ng-container>
</div>